@if (vm$ | async; as vm) {
  <div [innerHtml]="vm.content | safeHtml"></div>
}